<template>

    <div>
        <nav class="main-header navbar navbar-expand bg-dark navbar-light border-bottom">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" data-widget="pushmenu" href="#"><i class="fa fa-bars"></i></a>
                </li>
                <li class="nav-item d-none d-sm-inline-block">
                    <a href="http://www.trustpayonline.com/help" class="nav-link">Help</a>
                </li>
                <li class="nav-item d-none d-sm-inline-block">
                    <a href="http://www.trustpayonline.com/contact" class="nav-link">Contact Us</a>
                </li>
            </ul>

            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                     <router-link to="/myescrow/p2p/stage1" class="nav-link p2p-link">
                        
                        <p style="background: #3478f6; padding: 9px 25px; border-radius: 4px; margin-top: -9px;">
                            Create P2P Transaction
                        </p>
                    </router-link>
                </li>
                <li class="nav-item">
                    
                    <el-dropdown>
                      <span class="el-dropdown-link " style="color:#fff; font-size:15px;">
                       <i class="ion-person" style="border: 1px solid #f4f6f9; padding: 10px 16px; border-radius: 50%;"></i></router-link>
                      </span>
                      <el-dropdown-menu slot="dropdown" width="600">
                        <el-dropdown-item>Hi {{myProps}}</el-dropdown-item>
                        <el-dropdown-item><router-link to="/myescrow/profile/update" class="nav-link" style="color: #000; font-size: 15px;"><i class="ion-ios-person"></i>&nbsp; My Profile</router-link></el-dropdown-item>
                        <el-dropdown-item><router-link to="/myescrow/settings" class="nav-link" style="color: #000; font-size: 15px;"><i class="ion-ios-settings"></i>&nbsp; Settings</router-link></el-dropdown-item>
                         <el-dropdown-item><a href="#" class="nav-link" v-on:click="logout" style="color: #000; font-size: 15px;"><i class="ion-log-out"></i> &nbsp;Log Out</a></el-dropdown-item>
                       <!--  <el-dropdown-item>Action 3</el-dropdown-item>
                        <el-dropdown-item>Action 4</el-dropdown-item>
                        <el-dropdown-item>Action 5</el-dropdown-item> -->
                      </el-dropdown-menu>
                    </el-dropdown>
                </li>
                <li class="nav-item">
                   
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

export default {
     props: [
    'myProps'
  ],
    methods:{
        logout: function () {
            this.$session.destroy();
            this.$router.push('/');
        }
    }
}
</script>
<style scoped>
.el-dropdown-link{
    color: #fff !important;
    font-size: 15px;
    background: #343a40;
    padding: 8px 14px;
    cursor: pointer;
    font-weight: 300;
    display: block;
    /* border: 1px solid #f4f6f9; */
    margin-top: -1px;
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/dashNavigation.vue